import { AccountRole } from '../../../types/AccountRole.enum';
export const FOOTER_LINKS = [
    {
        title: 'Support',
        links: [
            {
                name: 'Check order status',
                url: '/about-contact#contact-chatbot',
            },
            {
                name: 'Shipping & Returns',
                url: '/about-shipping',
            },
            {
                name: 'Help/FAQ',
                url: '/about-faq',
            },
            {
                name: 'Terms of use',
                url: '/about-regulations',
            },
            {
                name: 'Mounting instructions',
                url: '/about-mounting',
            },
            {
                name: 'Contact us',
                url: '/about-contact',
            },
            {
                name: 'Copyrights',
                url: '/about-copyright',
            },
            {
                name: 'Privacy policy',
                url: '/about-privacy',
            },
        ],
    },
    {
        title: 'About',
        links: [
            {
                name: "What's a Displate?",
                url: '/whats-a-displate',
            },
            {
                name: 'Displate Club',
                url: '/join-displate-club',
            },
            {
                name: 'About us',
                url: '/about-us',
            },
            {
                name: 'Blog',
                url: 'https://blog.displate.com/',
            },
            {
                name: 'Career',
                url: '/career',
            },
        ],
    },
    {
        title: 'Earn with Displate',
        links: [
            {
                name: 'Sell your art',
                url: '/open-shop',
            },
            {
                name: 'Displate Shop Handbook',
                url: '/shop-handbook',
                displayFor: AccountRole.SHOP,
            },
        ],
    },
    {
        title: 'Media',
        links: [
            {
                name: 'Press Contact',
                url: '/media-contact',
            },
        ],
    },
];
//# sourceMappingURL=links.js.map